// extracted by mini-css-extract-plugin
export default {"deporteReferencias":"Deporte_deporteReferencias__2CLyj"};